<div
    class="fieldset"
    [class.dark]="dark"
    [ngClass]="{
        error: hasErrorString(),
        focused: isFocused,
        background: removeBackground,
        disabled_input: disabledInput,
    }"
    [ngStyle]="{ 'padding-right': icon ? '0px' : '', height: customHeight ? customHeight : '56px' }">
    <p
        data-cy="input-field-label"
        class="legend"
        [class.show]="showLegend && (!!inputValue || isFocused)"
        [class.error]="hasErrorString()"
        [class.focused]="isFocused"
        [class.dark]="dark">
        {{ legend | translate }}
    </p>
    <input
        #input
        data-cy="input-field"
        type="text"
        class="input"
        [readonly]="disabledInput"
        [class.dark]="dark"
        [class.error]="hasErrorString()"
        [class.focus]="isFocused"
        [(ngModel)]="inputValue"
        (focus)="handleFocus()"
        (blur)="handleBlur()"
        (ngModelChange)="handleChange()"
        [maxlength]="maxlength"
        [placeholder]="[isFocused ? ((placeholder ? placeholder : inputValue) | translate) : (legend | translate)]" />
    <mat-icon *ngIf="icon" [svgIcon]="icon" data-cy="input-field-icon" class="icon" />
    <ng-container *ngIf="unitText">
        <div class="unit-text">{{ unitText | translate }}</div>
    </ng-container>
</div>
<ng-container *ngIf="hasErrorString() && getErrorString()">
    <div data-cy="input-field-error-message" class="error-message">
        {{ getErrorString() }}
    </div>
</ng-container>
